// extracted by mini-css-extract-plugin
module.exports = {"hide":"styles_hide__2X754"};